import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { RolePermissions } from './role-permissions'
import { rolePermissionsActions } from './role-permission.actions'
import * as fromRolePermissions from './role-permissions.reducer'
import { RolePermissionsService } from './role-permissions.service'
import { concatMap, map } from 'rxjs/operators'

@Injectable()
export class RolePermissionsEffects extends ResourceEffects<RolePermissions> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public rolePermissionsService: RolePermissionsService
  ) {
    super(
      fromRolePermissions.FEATURE_NAME,
      rolePermissionsService,
      rolePermissionsActions,
      actions$
    )
  }

  sendTestById = createEffect(() =>
    this.actions$.pipe(
      ofType(rolePermissionsActions.sendTestById),
      concatMap((action) =>
        this.rolePermissionsService
          .sendTestById(action.id, action.toEmail)
          .pipe(
            map((response) =>
              rolePermissionsActions.setLoading({ isLoading: false })
            )
          )
      )
    )
  )
}
